import req from '../../api/request'

/**
 * Filters for one page of a player stats list. Absent fields are left off the
 * request (`req` drops `undefined`), so the server's own defaults apply.
 */
export interface StatsListQuery {
  sortBy?: string | number | null
  sort?: 'asc' | 'desc'
  goalie?: 0 | 1
  division_id?: string
  global?: 1
  player_name?: string
}

/** The pagination block the stats endpoints return under `meta`. */
export interface StatsPagination {
  current_page?: number | string
  per_page?: number
  count?: number
}

/** One page of a stats list, as the endpoint returns it. */
export interface StatsPage<Row = unknown> {
  data: Row[]
  meta?: { pagination?: StatsPagination }
}

/**
 * Fetches one page of a player stats list.
 *
 * The caller passes the endpoint path because the Statistics tabs choose it
 * from their filters — `/schedules/:id/stats`, `/schedules/:id/stats/team/:t`,
 * or the legacy `.../stats/players` variants all share this request and
 * response shape.
 */
export const getStatsPage = async <Row = unknown>(
  path: string,
  query: StatsListQuery,
  page: number,
  signal?: AbortSignal
): Promise<StatsPage<Row>> => {
  const response = await req(path, { query: { page, ...query }, signal })
  return {
    data: (response?.data ?? []) as Row[],
    meta: response?.meta,
  }
}
